module.exports = __webpack_public_path__ + "img/smc-logo-cropped.70aeabfb.png";